import { render, staticRenderFns } from "./SourceInfo.vue?vue&type=template&id=2d94c9b4&scoped=true&"
import script from "./SourceInfo.vue?vue&type=script&lang=js&"
export * from "./SourceInfo.vue?vue&type=script&lang=js&"
import style0 from "./SourceInfo.vue?vue&type=style&index=0&id=2d94c9b4&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d94c9b4",
  null
  
)

export default component.exports